import { render } from "./SlidersBlock.vue?vue&type=template&id=170f574e&scoped=true"
import script from "./SlidersBlock.vue?vue&type=script&lang=js"
export * from "./SlidersBlock.vue?vue&type=script&lang=js"

import "./SlidersBlock.vue?vue&type=style&index=0&id=170f574e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170f574e"]])

export default __exports__